<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '@/plugins/i18n'
import IconDocument from '@/assets/img/icon-document.svg'
import type { SuggestRecord } from '@/components/Search/types.ts'

// translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const props = defineProps<{
  items: SuggestRecord[]
  visible: boolean
  isLoading?: boolean
  highlightedIndex?: number
}>()

const emit = defineEmits<{
  (e: 'select', item: SuggestRecord): void
}>()

const hasItems = computed(() => props.items && props.items.length > 0)

const handleSelect = (item: SuggestRecord) => {
  emit('select', item)
}
</script>

<template>
  <div v-if="visible" class="standards-suggest">
    <div class="standards-suggest__panel">
      <div class="standards-suggest__list">
        <div
          v-if="isLoading"
          class="standards-suggest__item standards-suggest__item--state"
        >
          {{ t('loading') }}...
        </div>
        <div
          v-else-if="!hasItems"
          class="standards-suggest__item standards-suggest__item--state"
        >
          {{ t('noSuggestions') }}
        </div>
        <button
          v-else
          v-for="(item, index) in items"
          :key="item.id"
          type="button"
          class="standards-suggest__item"
          :class="{ 'standards-suggest__item--active': index === highlightedIndex }"
          @mousedown.prevent="handleSelect(item)"
        >
          <div class="standards-suggest__item-icon">
            <img :src="IconDocument" alt="Document icon" class="standards-suggest__doc-img" />
          </div>
          <div class="standards-suggest__item-content">
            <div
              class="standards-suggest__item-text"
              v-html="item.label"
            ></div>
            <div
              v-if="item.subtitle"
              class="standards-suggest__item-subtitle"
            >
              {{ item.subtitle }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
